import { HStack, Stack, Text, VStack } from '@genial/components';
import React from 'react';

import { TextWithSubtextSkeleton } from '../../../../../AssetsLoading';
import { FixedIncomeSharedInfoTypes, FixedIncomeSharedInfoTypesLoading } from '../types';

export const MaturityInfo: React.FC<FixedIncomeSharedInfoTypes> = ({ offer, w }) => {
  return (
    <Stack w={w}>
      <VStack space="stack.quarck" justifyContent="space-between">
        <Text variant="semibold">Prazo</Text>
        <HStack space="inline.quarck" alignItems="flex-end">
          <Text>{offer.maturityDateNormalized}</Text>
          <Text color="neutral.dark" fontSize="xs">
            Vencimento
          </Text>
        </HStack>
        <Text color="neutral.dark" fontSize="xs">
          {offer.dueDateNormalized} - Carência
        </Text>
      </VStack>
    </Stack>
  );
};

export const MaturityInfoLoading: React.FC<FixedIncomeSharedInfoTypesLoading> = ({ w }) => {
  return (
    <Stack w={w}>
      <VStack space="stack.quarck" justifyContent="space-between">
        <Text variant="semibold">Prazo</Text>
        <TextWithSubtextSkeleton />
      </VStack>
    </Stack>
  );
};
